import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue } from 'firebase/database';

// Firebase configuration (must match firebase-messaging-sw.js for messaging)
export const firebaseConfig = {
  apiKey: 'AIzaSyDfJLmQuJZ0JVMb_8dyidcj8Z08VPUCGao',
  authDomain: 'rsa-mobile-e7d3c.firebaseapp.com',
  databaseURL: 'https://rsa-mobile-e7d3c-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'rsa-mobile-e7d3c',
  storageBucket: 'rsa-mobile-e7d3c.firebasestorage.app',
  messagingSenderId: '379518275848',
  appId: '1:379518275848:web:81f782714893609ac71cbd',
};

let app = null;
let db = null;

export function getFirebaseApp() {
  if (!app) {
    app = initializeApp(firebaseConfig);
    db = getDatabase(app);
    console.log('📍 [WEB] Firebase initialized successfully');
  }
  return app;
}

export function initFirebase() {
  getFirebaseApp();
}

export function listenToVendorLocation(serviceId, callback) {
  getFirebaseApp();
  if (!db) throw new Error('Firebase not initialized');
  
  // Use Realtime Database path that matches the mobile app
  const locationRef = ref(db, `locations/${serviceId}`);
  
  console.log('📍 [WEB] Setting up listener for service:', serviceId);
  
  return onValue(locationRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      console.log('📍 [WEB] Location update received for service', serviceId, ':', data);
      
      // Validate the new data format
      if (isValidNewFormat(data)) {
        console.log('📍 [WEB] Valid new format data received:', data);
        callback(data);
      } else {
        console.warn('📍 [WEB] Invalid data format:', data);
        callback(null);
      }
    } else {
      console.log('📍 [WEB] No location data found for service:', serviceId);
      callback(null);
    }
  }, (error) => {
    console.error('📍 [WEB] Firebase listener error for service', serviceId, ':', error);
    callback(null);
  });
}

export function getServicePolyline(serviceId) {
  getFirebaseApp();
  if (!db) throw new Error('Firebase not initialized');
  
  const polylineRef = ref(db, `services/${serviceId}/polyline`);
  
  console.log('📍 [WEB] Getting polyline data for service:', serviceId);
  
  return new Promise((resolve, reject) => {
    onValue(polylineRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        console.log('📍 [WEB] Polyline data received for service', serviceId, ':', data);
        resolve(data);
      } else {
        console.log('📍 [WEB] No polyline data found for service:', serviceId);
        resolve(null);
      }
    }, (error) => {
      console.error('📍 [WEB] Firebase polyline listener error for service', serviceId, ':', error);
      reject(error);
    }, { onlyOnce: true }); // Only listen once to get the current value
  });
}

// Helper function to validate new data format
function isValidNewFormat(data) {
  if (!data) return false;
  
  // Check if this is a completed service (no location data but has status)
  if (data.service_status === 'service_resolved' || data.service_status === 'service_complete') {
    console.log('📍 [WEB] Service completed, no location data expected');
    return true; // Valid for completed services
  }
  
  // Check for required fields in new format for active services
  const requiredFields = [
    'current_lat', 'current_lng', 'end_location_lat', 'end_location_lng', 
    'endpoint_name', 'service_status', 'service_id', 'vendor_id'
  ];
  
  const hasRequiredFields = requiredFields.every(field => data[field] !== undefined);
  
  if (!hasRequiredFields) {
    console.error('📍 [WEB] Missing required fields:', requiredFields.filter(field => data[field] === undefined));
    return false;
  }
  
  return true;
}
